module.exports = __webpack_public_path__ + "app/principal/modals/modal-cgv-import-1o316d6U.html";